import { Panel } from 'components/Panel';
import { SaveButton } from 'components/SaveButton';
import { i18nKeys, useTranslation } from 'locales';

import {
  CommunicationLocalesFields,
  useCommunicationLocalesForm,
} from './CommunicationLocalesForm';

export const CommunicationLocalesCard = () => {
  const { t } = useTranslation();

  const { form, handleSave, isSaving } = useCommunicationLocalesForm();

  return (
    <Panel
      title={t(i18nKeys.FORM.PREFERENCES.COMMUNICATION_LANGUAGES.TITLE)}
      withBorder
      fullHeight
      pinFooter
      footer={
        <SaveButton onClick={handleSave} disabled={!form.isDirty()} loading={isSaving} hideIcon />
      }
    >
      <CommunicationLocalesFields form={form} />
    </Panel>
  );
};
